import React, { useState, useEffect } from 'react';
import { ScheduleTable } from './ScheduleTable';

export const CollapsibleScheduleSection = ({ schedule, allCustomDriverShifts }) => {
   const { name, rotation_weeks, rows } = schedule;
   const [collapsed, setCollapsed] = useState(rows.length === 0);

   const assignedCount = rows.filter((r) => r.driver).length;

   useEffect(() => {
      // if the section has rows and is collapsed, expand it
      if (rows.length > 0 && collapsed) {
         setCollapsed(false);
      }
   }, [rows.length]);

   const isScheduleFull = (schedule) => {
      const availablePositions = schedule.rotation_weeks;
      const assignedDrivers = new Set(schedule.rows.filter((r) => r.driver).map((r) => r.driver.rotation_position));

      return assignedDrivers.size >= availablePositions;
   };

   return (
      <div className="schedule-management__schedule-section">
         <div
            className={`schedule-management__schedule-header ${collapsed ? 'collapsed' : ''}`}
            onClick={() => setCollapsed(!collapsed)}
         >
            <div className="schedule-management__schedule-title">
               <i className="fa fa-chevron-down schedule-management__toggle-icon"></i>
               <div>
                  <div className={`schedule-management__schedule-code ${isScheduleFull(schedule) ? 'full' : ''}`}>
                     {name}
                  </div>
               </div>
            </div>
            <div className="schedule-management__schedule-info">
               <div className="schedule-management__schedule-meta">
                  <div className="schedule-management__meta-item">
                     <span className="schedule-management__meta-label">Rotation weeks:</span>
                     <span className="schedule-management__meta-value">{rotation_weeks}</span>
                  </div>
                  <div className="schedule-management__meta-item">
                     <span className="schedule-management__meta-label">Assigned drivers:</span>
                     <span className="schedule-management__meta-value">{assignedCount}</span>
                  </div>
               </div>
            </div>
         </div>

         <div className={`schedule-management__schedule-content ${collapsed ? 'hidden' : ''}`}>
            <ScheduleTable schedule={schedule} allCustomDriverShifts={allCustomDriverShifts} />
         </div>
      </div>
   );
};
